import { SubmissionState } from "@/api/submission-types";
import { pretty } from "@/utils/pretty";
import { grey, purple } from "@mui/material/colors";
import { StateChip, StateChipProps } from "./StateChip";

type Props = {
  state: SubmissionState;
  size?: StateChipProps["size"];
};

const colors = {
  unsubmitted: grey[500],
  submitted: purple[500],
  finalCheck: grey[500],
};

export function SubmissionStateChip({ state, size }: Props) {
  return (
    <StateChip
      size={size}
      label={pretty(state, "capitalLetters")}
      color={colors[state]}
    />
  );
}
